import React, { useState, useEffect, useContext } from 'react'
import { NavLink, Link, matchPath } from 'react-router-dom'
import { slide as OffcanvasMenu } from 'react-burger-menu'
import { useTranslation } from 'react-i18next'
import { createMarkup, setParams } from '../../utils'
import { apiDefaults, apiFetch, parseJSON } from  '../../api'
import Logo from '../Logo/Logo'
import './SideMenu.css'
import { MenuOpenContext } from '../../App'
import LangSelection from '../LangSelection/LangSelection'
import SearchForm from '../Search/SearchForm'

const Menu = () => {
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [menuOpen, setMenuOpen] = useContext(MenuOpenContext)
  const { t, i18n } = useTranslation()

  if (i18n.language === 'de') {
    return (
      <OffcanvasMenu className="Menu-offcanvas" width={250} isOpen={menuOpen} outerContainerId={"root"} customBurgerIcon={ false } onStateChange={state => setMenuOpen(state.isOpen)}>
        <Logo />
        <LangSelection/>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Einleitung" to={"/content/2433"}>Einleitung</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Aktuell" to={"/content/2439"}>Aktuell</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Verzeichnis der archive" to={"/content/2440"}>Verzeichnis der Archive</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Verzeichnisse v. juden" to={"/content/2441"}>Verzeichnisse von Juden</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Regeln" to={"/content/2442"}>Regeln</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Mitarbeiter" to={"/content/2443"}>Mitarbeiter</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Publikationen" to={"/content/2484"}>Publikationen</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Finanzierung" to={"/content/2438"}>Finanzierung</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="NavLinks" to={"/content/2436"}>Links</NavLink>
        </div>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Samuel-Steinherz-Stiftung" to={"/content/2437"}>Samuel-Steinherz-Stiftung</NavLink>
          </div>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Einloggen" to={"/login"}>Einloggen</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Registrieren" to={"/register"}>Registrieren </NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Odhlášení" to={"/logout"}>Odhlášení</NavLink>
        </div>
        <hr/>
        <SearchForm />
      </OffcanvasMenu>
    )
  } else {
    return (
      <OffcanvasMenu className="Menu-offcanvas" width={250} isOpen={menuOpen} outerContainerId={"root"} customBurgerIcon={ false } onStateChange={state => setMenuOpen(state.isOpen)}>
        <Logo/>
        <LangSelection/>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Úvod" to={"/content/11"}>Úvod</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Aktuálně" to={"/category/145"}>Aktuálně</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Seznam archivů" to={"/category/102"}>Seznam archivů</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Soupisy židů" to={"/content/500"}>Soupisy židů</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Pravidla" to={"/content/15"}>Pravidla</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Spolupracovníci" to={"/content/16"}>Spolupracovníci</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Publikace" to={"/content/1962"}>Publikace</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Financování" to={"/content/17"}>Financování</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Odkazy" to={"/content/18"}>Odkazy</NavLink>
        </div>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Nadace Samuela Steinherze" to={"/content/1977"}>Nadace Samuela Steinherze</NavLink>
        </div>
        <hr/>
        <div>
          <NavLink className="Menu-link Menu-second__link" title="Přihlášení" to={"/login"}>Přihlášení</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Registrace" to={"/register"}>Registrace</NavLink>
          <NavLink className="Menu-link Menu-second__link" title="Odhlášení" to={"/logout"}>Odhlášení</NavLink>
        </div>
        <hr/>
        <SearchForm />
      </OffcanvasMenu>
    )
  }
}

export default Menu
